import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import apiService from '../../services/api';
import './questionReportModal.scss';

const MAX_CHARS = 100;

const QuestionReportModal = ({ open, onClose, questionId, isLoggedIn }) => {
    const [comment, setComment] = useState('');
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleClose = () => {
        setComment('');
        setSuccess(false);
        setLoading(false);
        onClose();
    };

    const handleSubmit = async () => {
        if (!comment.trim()) return;
        setLoading(true);
        try {
            await apiService.questionReports.submit(questionId, comment.trim());
            setSuccess(true);
        } catch {
            alert("Xatolik yuz berdi. Qayta urinib ko'ring.");
        } finally {
            setLoading(false);
        }
    };

    const handleCommentChange = (e) => {
        const value = e.target.value.replace(/<[^>]*>/g, '');
        if (value.length <= MAX_CHARS) setComment(value);
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>Savolni xabar qilish</DialogTitle>
            <DialogContent>
                {!isLoggedIn ? (
                    <p className="report-login-prompt">
                        Xabar yuborish uchun tizimga kiring.
                    </p>
                ) : success ? (
                    <div className="report-success">
                        <CheckCircleIcon />
                        <p>Xabaringiz yuborildi. Rahmat!</p>
                    </div>
                ) : (
                    <>
                        <TextField
                            autoFocus
                            multiline
                            rows={3}
                            fullWidth
                            variant="outlined"
                            placeholder="Savol haqida izoh yozing..."
                            value={comment}
                            onChange={handleCommentChange}
                            sx={{ mt: 1 }}
                        />
                        <p className="report-char-counter">{comment.length}/{MAX_CHARS}</p>
                    </>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Yopish</Button>
                {isLoggedIn && !success && (
                    <Button
                        onClick={handleSubmit}
                        disabled={!comment.trim() || loading}
                        variant="contained"
                        sx={{ backgroundColor: '#03989F', '&:hover': { backgroundColor: '#027a80' } }}
                    >
                        Yuborish
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default QuestionReportModal;